import type { FrontendWidget } from '../types';
import type {
  VideoRecommendationsWidgetConfig,
  VideoRecommendationsWidgetResolved,
} from './types';
import { VideoRecommendationsComponent } from './VideoRecommendationsComponent';
import { VideoRecommendationsComponentB } from './VideoRecommendationsComponentB';
import { VideoRecommendationsComponentC } from './VideoRecommendationsComponentC';

export const videoRecommendationsWidget: FrontendWidget<
  VideoRecommendationsWidgetConfig,
  VideoRecommendationsWidgetResolved
> = {
  componentType: 'widgets.video-recommendations-widget',
  displayName: 'Video Recommendations Widget',
  ComponentA: VideoRecommendationsComponent,
  ComponentB: VideoRecommendationsComponentB,
  ComponentC: VideoRecommendationsComponentC,
  resolveSync: (config) => config,
};
